const Routers = {
  All: "/*",
  Login: "/login",
  Dashboard: "/dashboard",

  // Contracts
  Contracts: "/contracts",
  ContractDetail: "/contracts/:contractId",
  ContractRenewals: "/contract-renewals",

  // Applications
  Applications: "/applications",
  ApplicationDetail: "/applications/:applicationId",
  ApplicationIntake: "/application-intake",

  // Affiliates
  Affiliates: "/affiliates",
  AffiliateNew: "/affiliates/new",
  AffiliateDetail: "/affiliates/:affiliateId",
  AffiliateInquiries: "/affiliate-inquiries",
  AffiliateInquiryDetail: "/affiliate-inquiries/:inquiryId",
  AffiliateApplications: "/affiliate-applications",
  AffiliateApplicationDetail: "/affiliate-applications/:applicationId",
  ShopRegistrationApplies: "/shop-registration-applies",
  ShopRegistrationApplyDetail: "/shop-registration-applies/:shopRegistrationApplyId",

  // Variable Cost
  VariableCostRegistration: "/variable-cost-registration",
  VariableCostApplications: "/variable-cost-applications",
  VariableCostApplicationDetail: "/variable-cost-applications/:variableCostId",

  // Subrogation
  SubrogationPayment: "/subrogation-payment",
  SubrogationPaymentDetailPage: "/subrogation-payment/:id",
  // SubrogationRequestRegister: "/subrogation-request-register",
  SubrogationRequestRegisterCreate: "/subrogation-request-register/create",

  // Delinquents
  Delinquents: "/delinquents",
  DelinquentDetail: "/delinquents/:borrowerCode",
  DelinquentsPoppo: "/delinquents-poppo",

  // Equipment
  // Equipment Warranty
  EquipmentWarranty: "/equipment-warranty",
  EquipmentWarrantyDetail: "/equipment-warranty/:id",
  // Equipment Guarantee
  EquipmentGuaranteeContract: "/equipment-guarantee-contract",

  // Customers
  // Customers: "/customers",

  // Inclusive Contract Application
  // InclusiveContractApplication: "/inclusive-contract-application",
  InclusiveContractApplicationManagement: "/inclusive-contract-application-management",
  InclusiveContractApplicationDetail: "/inclusive-contract-application-management/:inclusiveContractApplicationId",

  // Initial Billing
  InitialBilling: "/initial-billing",

  // Payment Management
  // PaymentManagement: "/payment-management",

  // Finance
  Finance: "/finance",
  Invoices: "/invoices",

  // Owner Remittance
  OwnerRemittance: "/owner-remittance",

  // Settings
  Settings: "/settings",
  SystemSettings: "/system-settings",

  // Buildings
  Buildings: "/buildings",

  // Owners
  Owners: "/owners",

  // Staff
  Staff: "/staff",

  // Blanket Contracts
  // BlanketContracts: "/blanket-contracts",

  // Items
  Items: "/items",
  ItemsCreate: "/items/create",
  ItemsDetail: "/items/:itemCode",
  DocumentTemplates: "/document-templates",
  DocumentTemplatesCreate: "/document-templates/new",
  DocumentTemplateDetail: "/document-templates/:xlsCode",

  // Cancel contract
  CancelContracts: "/cancel-contract",
  CancelContractDetail: "/cancel-contract/:id",

  // Notices
  Notices: "/notices",
  NoticesCreate: "/notices/new",
  NoticeEdit: "/notices/:id/edit",
  NoticeDetail: "/notices/:id",
  NotificationDeliveries: "/notification-deliveries",

  // Error
  BadRequest: "/400",
  Forbidden: "/403",
  NotFound: "/not-found",

  // Health Check
  HealthCheck: "/healthcheck-fe",

  // Maintenance
  Maintenance: "/maintenance"
};

export default Routers;
